import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"

Chart.register(...registerables)

export default class extends Controller {
  static targets = ["countChart", "costChart"]
  static values = { chartsDataUrl: String }

  connect() {
    this.currentPeriod = "weekly"
    this.countChartInstance = null
    this.costChartInstance = null
    this.loadChartData()
  }

  switchPeriod(event) {
    const period = event.currentTarget.dataset.period
    if (period === this.currentPeriod) return

    this.currentPeriod = period
    event.currentTarget.parentElement.querySelectorAll("button").forEach((btn) => {
      btn.classList.remove("active")
    })
    event.currentTarget.classList.add("active")

    this.loadChartData()
  }

  async loadChartData() {
    try {
      const url = new URL(this.chartsDataUrlValue, window.location.origin)
      url.searchParams.set("period", this.currentPeriod)
      const response = await fetch(url.toString(), { credentials: "same-origin" })
      if (!response.ok) throw new Error(`HTTP ${response.status}`)
      const data = await response.json()
      this.renderCharts(data)
    } catch (error) {
      console.error("[MessengerCharts] Error loading chart data:", error)
      this.renderCharts({ labels: [], datasets: { conversations: [], cost: [] }, period: this.currentPeriod })
    }
  }

  renderCharts(data) {
    const labels = this._formatLabels(data.labels || [])
    const datasets = data.datasets || {}
    this._renderCountChart(labels, datasets.conversations || [])
    this._renderCostChart(labels, datasets.cost || [])
  }

  _renderCountChart(labels, counts) {
    if (this.countChartInstance) {
      this.countChartInstance.destroy()
      this.countChartInstance = null
    }
    if (!this.hasCountChartTarget) return

    this.countChartInstance = new Chart(this.countChartTarget.getContext("2d"), {
      type: "bar",
      data: {
        labels,
        datasets: [
          {
            label: "Beszélgetések",
            data: counts,
            backgroundColor: "rgba(108, 117, 125, 0.7)",
            borderColor: "rgba(108, 117, 125, 1)",
            borderWidth: 2,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { position: "top" } },
        scales: {
          y: { beginAtZero: true },
        },
      },
    })
  }

  _renderCostChart(labels, costs) {
    if (this.costChartInstance) {
      this.costChartInstance.destroy()
      this.costChartInstance = null
    }
    if (!this.hasCostChartTarget) return

    this.costChartInstance = new Chart(this.costChartTarget.getContext("2d"), {
      type: "bar",
      data: {
        labels,
        datasets: [
          {
            label: "AI költség ($)",
            data: costs,
            backgroundColor: "rgba(255, 159, 64, 0.7)",
            borderColor: "rgba(255, 159, 64, 1)",
            borderWidth: 2,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { position: "top" } },
        scales: {
          x: {
            title: {
              display: true,
              text: this.currentPeriod === "monthly" ? "Hónap" : "Hét",
            },
          },
          y: {
            beginAtZero: true,
            title: { display: true, text: "USD" },
            ticks: {
              callback: (value) => `$${Number(value).toFixed(6)}`,
            },
          },
        },
      },
    })
  }

  _formatLabels(labels) {
    return labels.map((label) => {
      if (this.currentPeriod === "monthly") {
        const [year, month] = label.split("-")
        return new Date(year, month - 1).toLocaleDateString("hu-HU", {
          month: "short",
          year: "numeric",
        })
      }
      const date = new Date(label)
      return date.toLocaleDateString("hu-HU", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    })
  }
}
